import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  href: "/account/logout",
  target: "_blank"
}
const _hoisted_2 = ["innerHTML"]

import { object, string } from 'yup';
import { reactive, useTemplateRef } from 'vue';
import RegistrationField from '@/modules/registration/components/RegistrationField.vue';
import { useTimezonesQuery } from '@/entities/staged/timezone';
import BaseButton from '@/shared/legacy/ui/button/button.vue';
import { appConfig } from '@/shared/legacy/lib/config/app-config';
import { DateTimeHelper } from '@/shared/legacy/lib/util/date-time-helper';
import { XSRFHelper } from '@/shared/legacy/lib/util/xsrf-helper';
import FieldsLayout from '@/shared/legacy/ui/fields-layout/fields-layout.vue';
import FormLayout from '@/shared/legacy/ui/form-layout/form-layout.vue';
import {
  ValidationField,
  ValidationErrors,
  ValidationProvider,
  yupResolver
} from '@/shared/legacy/ui/validate-form';
import { useI18N } from '@/shared/legacy/lib/use-i18n';
import BaseSelectDropdown from '@/shared/ui/base-list/base-select-dropdown.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DemoForm',
  props: {
    fields: {},
    serverErrors: {}
  },
  setup(__props: any) {



const i18n = useI18N();

const lang = appConfig.get('lang');
const instanceRegion = appConfig.get('instanceRegion');

const localeItems = [
  {
    id: 'ru_RU',
    name: i18n('language.ru')
  },
  {
    id: 'en_US',
    name: i18n('language.en')
  }
];
const defaultLocale = lang !== 'ru' || instanceRegion === 'AI' ? 'en_US' : 'ru_RU';
const defaultValues = {
  name: '',
  username: '',
  position: '',
  phone: '',
  email: '',
  _xsrf: XSRFHelper.getToken(),
  ...__props.fields,
  type: 'internal',
  locale: defaultLocale,
  timezone: lang === 'ru' ? DateTimeHelper.browserTimezone : 'Europe/Berlin'
};

const timezonesQuery = reactive(useTimezonesQuery());

const resolver = yupResolver(
  object({
    name: string().required(),
    username: string().required(),
    position: string().required(),
    phone: string().required().min(7),
    email: string().required().email(),
    locale: string().required(),
    timezone: string().required()
  })
);

const showLangSelect = instanceRegion !== 'AI';
const privacyPolicyLink = `<a href="/docs/privacy-policy" target="_blank">${i18n('consent.link')}</a>`;
const loginLink = `/account/login?backurl=${encodeURIComponent(`/demo-create?code=${__props.fields.code}`)}`;

const form = useTemplateRef<HTMLFormElement>('form');

const onSubmit = () => {
  if (form.value) {
    form.value.$el.submit();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ValidationProvider), {
    "default-values": defaultValues,
    "default-errors": __props.serverErrors,
    resolver: _unref(resolver),
    "instant-validate": "",
    onSubmit: onSubmit
  }, {
    default: _withCtx(({ submitted, handleSubmit }) => [
      _createVNode(FormLayout, {
        ref_key: "form",
        ref: form,
        "gap-before": "100px",
        action: "/demo-create",
        method: "post",
        class: _normalizeClass(_ctx.$style.form),
        "data-qa": "demo-request-form",
        onSubmit: handleSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, _toDisplayString(_unref(i18n)('title')), 1),
          _createVNode(FieldsLayout, {
            class: _normalizeClass(_ctx.$style.container),
            gap: "20px"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ValidationField), {
                hidden: "",
                name: "_xsrf"
              }),
              _createVNode(_unref(ValidationField), {
                hidden: "",
                name: "code"
              }),
              _createVNode(_unref(ValidationField), {
                hidden: "",
                name: "type"
              }),
              _createVNode(RegistrationField, {
                placeholder: _unref(i18n)('name'),
                field: "name",
                submitted: submitted,
                autofocus: ""
              }, null, 8, ["placeholder", "submitted"]),
              _createVNode(RegistrationField, {
                placeholder: _unref(i18n)('username'),
                submitted: submitted,
                field: "username"
              }, null, 8, ["placeholder", "submitted"]),
              _createVNode(RegistrationField, {
                placeholder: _unref(i18n)('position'),
                submitted: submitted,
                field: "position"
              }, null, 8, ["placeholder", "submitted"]),
              _createVNode(RegistrationField, {
                placeholder: _unref(i18n)('phone'),
                type: "tel",
                field: "phone",
                submitted: submitted,
                "show-only-one-error": ""
              }, null, 8, ["placeholder", "submitted"]),
              _createVNode(RegistrationField, {
                placeholder: _unref(i18n)('email'),
                type: "email",
                field: "email",
                submitted: submitted,
                "show-only-one-error": ""
              }, {
                error: _withCtx(({ message }) => [
                  (message === 'error.need_login')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(i18n)('need-login')) + " ", 1),
                        _createElementVNode("a", { href: loginLink }, _toDisplayString(_unref(i18n)('need-login.login')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(message), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["placeholder", "submitted"]),
              _createVNode(_unref(ValidationField), {
                name: "locale",
                class: _normalizeClass(_ctx.$style.selectContainer),
                hidden: !showLangSelect
              }, {
                default: _withCtx(({ id, modelValue, invalid, onChange, name }) => [
                  _createVNode(BaseSelectDropdown, {
                    id: id,
                    class: _normalizeClass([_ctx.$style.select, { [_ctx.$style.invalid]: invalid && submitted }]),
                    items: localeItems,
                    "model-value": modelValue,
                    "show-checkbox": "",
                    name: name,
                    "onUpdate:modelValue": onChange
                  }, null, 8, ["id", "class", "model-value", "name", "onUpdate:modelValue"])
                ]),
                error: _withCtx(({ error }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style.error)
                  }, _toDisplayString(error.message), 3)
                ]),
                _: 2
              }, 1032, ["class", "hidden"]),
              _createVNode(_unref(ValidationField), {
                name: "timezone",
                class: _normalizeClass(_ctx.$style.selectContainer)
              }, {
                default: _withCtx(({ id, modelValue, invalid, onChange, name }) => [
                  _createVNode(BaseSelectDropdown, {
                    id: id,
                    class: _normalizeClass([_ctx.$style.select, { [_ctx.$style.invalid]: invalid && submitted }]),
                    items: timezonesQuery.data.items,
                    "model-value": modelValue,
                    "show-checkbox": "",
                    name: name,
                    "onUpdate:modelValue": onChange
                  }, null, 8, ["id", "class", "items", "model-value", "name", "onUpdate:modelValue"])
                ]),
                error: _withCtx(({ error }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.$style.error)
                  }, _toDisplayString(error.message), 3)
                ]),
                _: 2
              }, 1032, ["class"]),
              _createVNode(BaseButton, {
                class: _normalizeClass(_ctx.$style.button),
                name: "create",
                type: "submit",
                "data-qa": "save"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n)('submit')), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_unref(ValidationErrors), {
                name: "common",
                all: false
              }, {
                default: _withCtx(({ message }) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.error)
                  }, [
                    (message === 'error.need_logout')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(i18n)('need-logout')) + " ", 1),
                          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("a", {
                            href: loginLink,
                            target: "_blank"
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(i18n)('need-logout.goto')), 1)
                          ]),
                          _cache[1] || (_cache[1] = _createTextVNode("  ·  ", -1)),
                          _createElementVNode("a", _hoisted_1, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(i18n)('logout')), 1)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(message), 1)
                        ], 64))
                  ], 2)
                ]),
                _: 1
              }),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.$style.privacyPolicy),
                innerHTML: _unref(i18n)('consent') + privacyPolicyLink
              }, null, 10, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["class"])
        ]),
        _: 2
      }, 1032, ["class", "onSubmit"])
    ]),
    _: 1
  }, 8, ["default-errors", "resolver"]))
}
}

})